<template>
	<view class="dropdown-container">
		<!-- 显示选中的项 -->
		<view class="selected-item">
			<view class="icon-view"  @click="toggleDropdown" :class="isOpen?'active':''">
				<input class="item-input" readonly :modelValue="modelValue" v-model="label" @input="handleInput"  placeholder="Please select the breed"/>
				<Icon 
					:icon="isOpen ? 'mdi:chevron-up' : 'mdi:chevron-down'" 
					:width="20" 
					:height="20"
					color="#666"
					/>
			</view>
		</view>
		
		<!-- 下拉列表 -->
		<div class="dropdown-list"  v-if="isOpen">
			<view class="body-head-view">
				<view style="flex:1; padding:0 10px;height:32px;align-items: center;">
					<view class="icon-view" >
						<Icon 
						icon="mdi:magnify" 
						:width="24" 
						:height="24" 
						color="#bbb"
						/>
						<input class="item-input"  @input="localSearch" placeholder="Please input your search text"/>
					</view>
				</view>
				<view class="self-btn" @click="toggleDropdown">Cancel</view>
			</view>
			<view class="body-body-view">
				<view class="dropdown-item" v-for="(item, index) in list" :key="index" @click = "selectItem(item)">
					<text class="item-text">{{ item.label }}</text>
				</view>
			</view>
			<view class="body-tail-view">
				<view class="self-input-view">
					<input class="self-input" type="text" v-model="mannualBreedItem" :placeholder="'Mannual Adding'"/>
					<view class="self-btn" @click="manualConfirm">Confirm</view>
				</view>
			</view>
		</div>
	</view>
</template>

<script>
import { Icon } from '@iconify/vue';

	export default {
		components: {
			Icon
		},
		name: 'ImageSelect',
		props: {
			items: {
				type: Array,
				default: () => []
			},
			modelValue:{
				type: String,
				default:'',
			},
		},
		data() {
			return {
				isOpen: false,
				// 列表数据
				list: [],
				originList: this.items,
				label:"",
				petValue:"",
				mannualBreedItem:''
			}
		},

		created(){
		},

		mounted(){
		},

		watch: {
			items: {
				handler(newVal) {
					this.list = newVal;
					this.label = ""
				},
				immediate: true,  // 关键：立即执行，包括初始值
				deep: true
			}

		},
	
		methods: {

	
			toggleDropdown() {
				this.isOpen = !this.isOpen
			},
			selectItem(item) {
				this.isOpen = false
				this.label = item.label
				this.$emit('update:modelValue', item.value);
			},
			handleInput(e){
				this.$emit('update:modelValue', e.detail.value);
			},
			localSearch(e){
				let searchText = e.target.value
				if(!searchText || !searchText.trim()){
					this.list = this.items;
					return;
				}
				this.list = this.items.filter(item => item.label.includes(searchText));
				console.log(this.list)
			},
			close(){
				this.isOpen = false;
			},
			manualConfirm(){
				this.label = this.mannualBreedItem
				console.log(this.label)
				this.$emit("mannualAdd", this.label)
				const value =  "::"+this.label;
				this.$emit('update:modelValue', value);
				this.isOpen = !this.isOpen;

			}

		}
	}
</script>

<style scoped>
	.dropdown-container {
		width: 100%;
		box-sizing: border-box;
	}

	.selected-item {
		display: flex;
		align-items: center;
		cursor: pointer;
		width: 100%;
		box-sizing: border-box;
		height:30px;
	}
	
	.dropdown-list-view{
		width:100%;
		display: flex;
		height: 300px;
	}
	
	.selected-view{
		display: flex;
		align-items: center;
		justify-content: center;
		border-bottom: 1px solid #E6DFCF;
		padding:10px 10px 10px 0;
		width:100%;
	}
	
	.selected-view:hover {
		background-color: #E6DFCF;
	}

	.dropdown-list {
		position: absolute;
		width: 320px;
		background: white;
		z-index: 100;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
		background-color: #fff;
		height: 240px;
		display:flex;
		flex-direction: column;
		border:1px solid #E7E1D7;
	}

	.dropdown-item {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);top:20px;
		flex:1;
	}


	.dropdown-item:hover {
		background-color: #E6DFCF;
	}
	
	.body-head-view {
		display: flex;
		height: 48px;
		align-items: center;
		padding-right:5px;
		
	}
	.body-body-view {
		overflow: auto;
		height:240px;
		flex:1;
		border:1px solid #E6DFCF;
	}
	
	.item-text {
		font-size: 14px;
		display: flex;
		align-items: center;
		flex:1;
		border-bottom: 1px solid #E6DFCF;
	}
	.body-tail-view {
		display: flex;
		height: 48px;
		align-items: center;
	}
	
	.item-icon {
		width: 24px;
		height: 16px;
		background: url('@/assets/images/flags.png') no-repeat 0 0; /* 雪碧图路径 */
		/* background-position: -1px -69px; */
		background-size: 24px 4012px;
		overflow: hidden;
	}


	.input-item-container{
		width:100%;
		display: flex;
		height: 30px;
		border:1px solid #E7E1D7;
		border-top-right-radius: 6px;
		border-bottom-right-radius:6px;
		
	}
	
	.icon-view{
		display: flex;
		height: 100%;
		flex:1;
		justify-content: center;
		align-items: center;
		padding-left: 10px;
		padding-right: 10px;
		border:1px solid #E7E1D7;
		border-radius: 6px;
		
	}
	
	.icon-view.active{
		background-color: #fff;
	}

	.item-input {
		width: 100%;
		font-size: 16px;
		border:none;
		flex:1;
		border-radius: 6px;
	}

	.item-input::placeholder{
		font-size: 12px;
	}
	
	.area-code{
		display: flex;
		background-color: #fff;
		font-size: 14px;
		min-width: 40px;
		padding-left: 5px;
		align-items: center;
			
	}

	.self-input-view{
		flex:1;
		display: flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		padding:0 5px;
	}
	.self-input{
		flex: 1;
		border: 1px solid #c46361;
		border-radius: 8px;
		font-size: 12px;
		margin-right: 5px;
		height:32px;
		align-items: center;
		padding-left:6px;
		
		
	}

	.self-input::placeholder{
		font-size: 12px;
		color: #b58787;
	}

	.self-btn{
		display:flex;
		flex-shrink: 0;
		width:72px; 
		align-items: center;
		background-color: #CE201C;
		background: linear-gradient(to bottom, #F03B34 0%, #8E0807 100%);
		color:#fff;
		height: 32px;
		justify-content: center;
		border-radius: 6px;
	}

	@media (max-width: 895px){
		.dropdown-list{
			width:260px;
		}
		.self-btn{
			font-size:12px;
			width:60px;
		}
		.item-input{
			font-size: 12px;
		}
	}
	
</style>